import { getSortedTowLog } from '../../tow-log';
import type { ICprMathContext } from '../interface/cpr-math-context.interface';
import { getTowedMiles } from './towed-miles';

/** Gets the `shipSpeed` in miles per hour for a tow. */
export function getShipSpeed(context: ICprMathContext<unknown>): number | null {
  if (context.tow?.shipSpeed) {
    return context.tow.shipSpeed;
  }

  let { towLog } = context;

  if (!towLog?.length || towLog.length < 2) {
    return null;
  }

  towLog = getSortedTowLog(towLog);

  const towedMiles = getTowedMiles(context);

  if (!towedMiles) {
    throw Error('Cannot determine towed miles');
  }

  let totalDurationMS = 0;
  let haulTime: number | undefined;

  const lastEventIndex = towLog.length - 1;

  for (let i = 0, event = towLog[i]!; i < towLog.length; event = towLog[++i]!) {
    switch (event.eventCode) {
      case 'SHOOT':
        if (i == 0) {
          totalDurationMS -= (event.eventDate as Date).getTime();
          continue;
        } else {
          throw new TypeError('First chronological event must be SHOOT type');
        }

      case 'HAUL':
        if (i == lastEventIndex) {
          totalDurationMS += (event.eventDate as Date).getTime();
          continue;
        } else {
          throw new TypeError('Last chronological event must be HAUL type');
        }

      case 'MIDHAUL':
        if (haulTime) {
          throw new TypeError('Detected consecutive MIDHAUL type');
        } else {
          haulTime = (event.eventDate as Date).getTime();
          continue;
        }

      case 'MIDSHOOT':
        if (haulTime) {
          totalDurationMS -= (event.eventDate as Date).getTime() - haulTime;
          haulTime = undefined;
          continue;
        } else {
          throw new TypeError('Detected MIDSHOOT without preceding MIDHAUL');
        }
    }
  }

  // Return in hours (from millisecs)
  return (towedMiles / totalDurationMS) * 36e5;
}
